// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__287h0","question":"styles_question__g3vTw","description":"styles_description__2XPbS"};